<template>
    <div class="payable_manage_wrap" v-loading="loading">
        <div class="aside-left">
            <ul>
                <li
                    v-for="item in sourceList"
                    :key="item.id"
                    :class="{ active: source_type == item.source_type }"
                    @click="handleClickTypeTab(item)"
                >
                    <i class="iconfont" :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                </li>
            </ul>
            <div class="aside_left_static">
                <ul>
                    <li
                        v-for="item in statisticsTypeList"
                        :key="item.type"
                        :class="{ active: statisticsTypeActive == item.type }"
                        @click="handleClickStaticTypeTab(item)"
                    >
                        <i class="iconfont" :class="item.icon"></i>
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="content-right">
            <template v-if="source_type !== ''">
                <UnpaidPayment v-if="source_type === 'unpaid_payment'" />
                <ReceivableList :source_type="source_type" v-else />
            </template>
            <template v-else>
                <ReceivableStatistics />
            </template>
        </div>
    </div>
</template>
<script>
import ReceivableList from "./receivable_list.vue";
import UnpaidPayment from "./unpaid_payment.vue";
import ReceivableStatistics from "./receivable_statistics.vue";
export default {
    name: "ReceivableManage",
    components: { ReceivableList, UnpaidPayment, ReceivableStatistics },
    data() {
        return {
            loading: false,
            source_type: "order", // 来源类型
            sourceList: [
                { name: "订单回款应收", source_type: "order", icon: "icon-dingdanhuikuanyingshou" },
                { name: "采购退款应收", source_type: "purchase_refund", icon: "icon-a-caigoutuikuanyingshou1" },
                { name: "订单未回款明细", source_type: "unpaid_payment", icon: "icon-dingdanweihuikuanmingxi" },
            ], // 应收来源
            statisticsTypeActive: "",
            statisticsTypeList: [{ type: 1, name: "应收统计", icon: "icon-yingshoutongji" }],
        };
    },
    activated() {
        if(this.$route.query && this.$route.query.source_type) {
            this.source_type = this.$route.query.source_type
        } else {
            this.source_type = "order";
        }
    },
    created() {
        if(this.$route.query && this.$route.query.source_type) {
            this.source_type = this.$route.query.source_type
        } else {
            this.source_type = "order";
        }
    },
    methods: {
        handleClickTypeTab(item) {
            this.source_type = item.source_type;
            this.statisticsTypeActive = "";
        },
        handleClickStaticTypeTab(item) {
            this.statisticsTypeActive = item.type;
            this.source_type = "";
        },
    },
};
</script>
<style lang="scss" scoped>
.payable_manage_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    .aside-left {
        width: 196px;
        flex-shrink: 0;
        padding: 12px 8px;

        ul {
            li {
                width: 100%;
                padding: 8px;
                display: flex;
                align-items: center;
                gap: 8px;
                cursor: pointer;
                color: rgba(102, 102, 102, 100);
                border-radius: 4px;
                font-weight: 400;

                span {
                    font-size: 14px;
                    letter-spacing: 0px;
                    line-height: 22px;
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
                &.active {
                    background: rgba(41, 144, 255, 0.16);
                    font-weight: 700;
                    color: #2990ff;
                }
            }
        }
        .aside_left_static {
            position: relative;
            margin-top: 8px;
            padding-top: 8px;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 3px;
                right: 3px;
                height: 1px;
                background-color: rgba(232, 232, 232, 1);
            }
        }
    }
    .content-right {
        flex: 1;
        border-left: 1px solid rgba(232, 232, 232, 1);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .el-tabs {
            ::v-deep {
                .el-tabs__nav {
                    margin: 0 16px;
                }
                .el-tabs__header {
                    margin: 0;
                }
                .el-tabs__item {
                    padding: 0 16px !important;
                    height: 48px;
                    line-height: 48px;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                    &.is-active {
                        font-weight: 700;
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
        .content_right_wrap {
            flex: 1;
            padding: 16px;
        }
    }
}
.dialog_label_text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 4px;
}
</style>
